// src/guards/is-array/is-array.ts
var isArray = (value) => Array.isArray(value);

export {
  isArray
};
